import Button from '@/shared/components/Button';
import Input from '@/shared/components/Input';
import Select from '@/shared/components/Select';
import '@/styles/design-system.css';

import UsageSummary from './UsageSummary';
import UsageTable from './UsageTable';
import useUsageData from './useUsageData';

const BillingMetrics = () => {
  const {
    filters, updateFilter, clearFilters, hasFilters, facets,
    summary, rows, totalCount, isLoading,
    page, setPage, totalPages, sort, toggleSort,
  } = useUsageData();

  return (
    <div className="th !overflow-visible">
      <div className="mx-auto min-w-0 max-w-7xl px-6 py-8">
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-foreground">Usage Tracking</h2>
          <p className="mt-1 text-sm text-muted-foreground">
            Every AI call recorded against a firm, with the tokens it used and what it cost. Click a row for its full details.
          </p>
        </div>

        <div className="mb-6 flex flex-wrap items-end gap-3">
          <Input type="date" label="From" value={filters.from} onChange={(event) => updateFilter('from', event.target.value)} wrapperClassName="w-40" />
          <Input type="date" label="To" value={filters.to} onChange={(event) => updateFilter('to', event.target.value)} wrapperClassName="w-40" />
          <Select label="Firm" placeholder="All firms" value={filters.firmId} options={facets.firms} onValueChange={(value) => updateFilter('firmId', value)} clearable wrapperClassName="w-52" />
          <Select label="Feature" placeholder="All features" value={filters.feature} options={facets.features} onValueChange={(value) => updateFilter('feature', value)} clearable wrapperClassName="w-52" />
          <Select label="Model" placeholder="All models" value={filters.aiModel} options={facets.models} onValueChange={(value) => updateFilter('aiModel', value)} clearable wrapperClassName="w-52" />
          {hasFilters ? <Button variant="ghost" size="sm" onClick={clearFilters}>Clear filters</Button> : null}
        </div>

        <UsageSummary summary={summary} />
        <UsageTable
          rows={rows}
          isLoading={isLoading}
          sort={sort}
          onSort={toggleSort}
          page={page}
          totalPages={totalPages}
          totalCount={totalCount}
          onPageChange={setPage}
        />
      </div>
    </div>
  );
};

export default BillingMetrics;
